
import { NgModule } from '@angular/core';
import { PublicFunction, TnxSharedModule } from 'tnx-shared';
import { SignalRModule } from 'ng2-signalr';
import { environment } from '../environments/environment';
import { AppRoutes } from './app.routing';
import { AppComponent } from './app.component';
import { AuthenAppComponent } from './authen-app/authen-app.component';
import { AnonymousAppComponent } from './anonymous-app/anonymous-app.component';
import { MenuMobileAppComponent } from './menu-mobile-app/menu-mobile.component';
import { AppAnonymousTopBarComponent } from './app-anonymous.topbar.component';
import { XacNhanFormComponent } from './xac-nhan-form/xac-nhan-form.component';
import { BrowserModule } from '@angular/platform-browser';
import { ResetPasswordFrontEndComponent } from './reset-password/reset-password.component';
import { FaqComponent } from './faq/faq.component';
import { LockLichComponent } from './lock-lich/lock-lich.component';

export function getTnComponentConfigProvider() {
    return { environment, appCode: 'FRONTEND' };
}

export function getImport() {
    return PublicFunction.importRootModule(environment);
}

export function getSignalrConfig() {
    return PublicFunction.getSignalrConfig(environment);
}

PublicFunction.registerLocaleData();

@NgModule({
    imports: [
        ...getImport(),
        TnxSharedModule.forRoot(getTnComponentConfigProvider),
        SignalRModule.forRoot(getSignalrConfig),
        AppRoutes,
        BrowserModule
    ],
    providers: PublicFunction.useRootProvider(environment),

    bootstrap: [AppComponent],
    declarations: [AppComponent,
        AppAnonymousTopBarComponent,
        MenuMobileAppComponent,
        AuthenAppComponent,
        AnonymousAppComponent,
        XacNhanFormComponent,
        ResetPasswordFrontEndComponent,
        LockLichComponent,
        FaqComponent
    ]
})
export class AppModule { }

